import { render, staticRenderFns } from "./UserProtocol.vue?vue&type=template&id=3f1b0deb&scoped=true"
import script from "./UserProtocol.vue?vue&type=script&lang=js"
export * from "./UserProtocol.vue?vue&type=script&lang=js"
import style0 from "./UserProtocol.vue?vue&type=style&index=0&id=3f1b0deb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b0deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1b0deb')) {
      api.createRecord('3f1b0deb', component.options)
    } else {
      api.reload('3f1b0deb', component.options)
    }
    module.hot.accept("./UserProtocol.vue?vue&type=template&id=3f1b0deb&scoped=true", function () {
      api.rerender('3f1b0deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/Docs/iOS/UserProtocol.vue"
export default component.exports